import ArtistsRoleStep from './artists-step/ArtistsRoleStepTab';
import ArtistsRole from './artists/ArtistsRoleTab';
import ProductContracts from './contracts/ProductContractTab';
import ContractsPerTrack from './contractsPerTrack/ContractsPerTrackTab';
import ExternalId from './external-id/ExternalIdTab';
import Titles from './titles/TitlesTab';
import TracksStep from './tracks-step/TracksStepTab';
import Tracks from './tracks/TracksRoleTab';

export default {
  ExternalId,
  Titles,
  ArtistsRole,
  ArtistsRoleStep,
  ProductContracts,
  ContractsPerTrack,
  Tracks,
  TracksStep,
};
